import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 列表列表
 */
export function getCarPageList(data) {
  return fetch({
    url: '/financial/car/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除车辆
 */
export function deleteCar(data) {
  return fetch({
    url: '/financial/car/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存车辆
 */
export function saveCar(data) {
  return fetch({
    url: '/financial/car/save',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 列表列表
 */
export function getCarList(data) {
  return fetch({
    url: '/financial/car/getCarList',
    method: 'GET',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Car/index.js